import { inject, provide } from 'vue';

const NON_CRITICAL_REQUESTS_KEY = Symbol('nonCriticalRequests');

/**
 * Composable for providing non-critical requests functionality
 * Used in the root App.vue to provide the requests
 */
export function provideNonCriticalRequests(requestsCallback) {
  let storedCallback = null;

  const setNonCriticalRequests = (callback) => {
    storedCallback = callback;
  };

  const executeNonCriticalRequests = async () => {
    if (storedCallback) {
      await storedCallback();
      storedCallback = null; // Clear after execution
    }
  };

  // Set the initial callback
  setNonCriticalRequests(requestsCallback);

  const api = {
    setNonCriticalRequests,
    executeNonCriticalRequests,
  };

  provide(NON_CRITICAL_REQUESTS_KEY, api);
  return api;
}

/**
 * Composable for consuming non-critical requests functionality
 * Used in components that need to execute non-critical requests
 */
export function useNonCriticalRequests() {
  const nonCriticalRequests = inject(NON_CRITICAL_REQUESTS_KEY);
  
  if (!nonCriticalRequests) {
    throw new Error('useNonCriticalRequests must be used within a component that provides nonCriticalRequests');
  }

  return nonCriticalRequests;
}
